import { PopoverProps } from '@mui/material';

const MuiPopoverDefaultProps: Partial<PopoverProps> = {
	anchorOrigin: {
		vertical: 'bottom',
		horizontal: 'center',
	},
	transformOrigin: {
		vertical: 'top',
		horizontal: 'center',
	},
};

export default {
	defaultProps: MuiPopoverDefaultProps,
};
// box-shadow: 0px 0px 30px 0px rgba(130, 125, 131, 0.15);
// box-shadow: 7px 4px 30px 0px rgba(130, 125, 131, 0.15);
